<template>
  <div class='tabs-view-container'>
    <router-link class="tabs-view" v-for="tag in Array.from(visitedViews)" :to="tag.path" :key="tag.path">
      <el-tag :closable="isDashboard(tag.path)" :type="isActive(tag.path)?'primary':'info'" @close='closeViewTabs(tag,$event)'>
        {{tag.title}}
      </el-tag>
    </router-link>
  </div>
</template>

<script>
export default {
  computed: {
    visitedViews () {
      return this.$store.state.app.visitedViews
    }
  },
  created () {
    if (!this.$router.matched) {
      this.$store.dispatch('app/addVisitedViews', this.$route)
    }
  },
  methods: {
    closeViewTabs(view, $event) {
      this.$store.dispatch('app/delVisitedViews', view).then((views) => {
        if (this.isActive(view.path)) {
          const latestView = views.slice(-1)[0]
          if (latestView) {
            this.$router.push(latestView.path)
          } else {
            this.$router.push('/')
          }
        }
      })
      $event.preventDefault()
    },
    generateRoute () {
      if (this.$route.matched[this.$route.matched.length - 1].name) {
        return this.$route.matched[this.$route.matched.length - 1]
      }
      this.$route.matched[0].path = '/'
      return this.$route.matched[0]
    },
    addViewTabs () {
      this.$store.dispatch('app/addVisitedViews', this.generateRoute())
    },
    isActive (path) {
      return path === this.$route.path
    },
    isDashboard ( path ) {
      return path !== '/dashboard'
    }
  },
  watch: {
    $route() {
      this.addViewTabs()
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .tabs-view-container {
    display: inline-block;
    vertical-align: top;
    width: 100%;
    .tabs-view {
      margin-left: 10px;
    }
    padding: 14px 0;
  }
</style>



// WEBPACK FOOTER //
// src/layout/components/TabsView.vue